"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class OneEntry {
    constructor(url, token) {
        this._LANGCODE_KEY = '$LANGCODE';
        this._url = url;
        if (token) {
            this._token = token;
        }
    }
    _getFullPath(path) {
        return (this._url + path);
    }
    async _fetchGet(path) {
        const response = await fetch(this._getFullPath(path), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-app-token': this._token,
            }
        });
        const result = await response.json();
        return result;
    }
    async _fetchPost(path, data) {
        const response = await fetch(this._getFullPath(path), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-app-token': this._token,
            },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        return result;
    }
    async _fetchDelete(path) {
        const response = await fetch(this._getFullPath(path), {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'x-app-token': this._token,
            },
        });
        const result = await response.json();
        return result;
    }
    _queryParamsToString(query) {
        let result = '';
        for (let key in query) {
            if (query[key] !== null) {
                result += `${key}=${query[key]}&`;
            }
        }
        return result.slice(0, (result.length - 1));
    }
    _parseLangFromString(str, lang) {
        const index = str.indexOf(this._LANGCODE_KEY);
        if (index === -1) {
            console.error('The endpoint does not contain a language template $LANGCODE');
        }
        else {
            return str.slice(0, index) + lang + str.slice(index + this._LANGCODE_KEY.length);
        }
    }
    async _fetchRequests(url, lang) {
        const langCode = (typeof lang === 'string') ? [lang] : lang;
        if (langCode.length === 1) {
            const response = await this._fetchGet(this._parseLangFromString(url, langCode[0]));
            if (response.hasOwnProperty('items') || Array.isArray(response)) {
                let result = Array.isArray(response) ? response : response.items;
                result = result.map(item => this._normalizeData(item));
                return result;
            }
            return this._normalizeData(response);
        }
        else {
            const dataList = [];
            await Promise.all(langCode.map(async (lang) => {
                await this._fetchGet(this._parseLangFromString(url, lang)).then((result) => {
                    result.hasOwnProperty('items') ? dataList.push(result.items) : dataList.push(result);
                });
            }));
            const baseData = dataList.splice(0, 1)[0];
            dataList.map(item => {
                if (Array.isArray(item)) {
                    item.map((subitem, index) => {
                        Object.assign(baseData[index].attributeValues, subitem.attributeValues);
                        Object.assign(baseData[index].localizeInfos, subitem.localizeInfos);
                    });
                }
                else {
                    Object.assign(baseData.attributeValues, item.attributeValues);
                    Object.assign(baseData.localizeInfos, item.localizeInfos);
                }
            });
            return baseData;
        }
    }
    _normalizeData(data) {
        const normalizeData = Object.assign({}, data);
        if (data.hasOwnProperty('attributeValues')) {
            const key = Object.keys(data.attributeValues);
            normalizeData.attributeValues = data.attributeValues[key[0]];
        }
        if (data.hasOwnProperty('localizeInfos')) {
            const key = Object.keys(data.localizeInfos);
            normalizeData.localizeInfos = data.localizeInfos[key[0]];
        }
        return normalizeData;
    }
}
exports.default = OneEntry;
